import React from 'react';
import { Link } from 'react-router-dom';
import '../custom.css';
import * as AppConstants from '../AppConstants';

export function Home() {
  return (
    <div className="container p-0">
      <div className="row justify-content-center align-items-center ">
        <div className="col-12 col-md-12 col-xl-12">
          <form>
            <div className="form-group">
              <div className="form-group card-bg-color rounded p-4">
                <h4 className="form-label bold mb-3">
                  Property Listings
                </h4>
                <Link
                  to="/Inspectionform"
                  style={{ textDecoration: 'none' }}
                >
                  <button className="btn btn-primary d-block blockquote mb-4 w-100 font-weight-bold text-center p-2">
                    New Property Listings
                  </button>
                </Link>
                <Link
                  to="/MyDraftListings"
                  style={{ textDecoration: 'none' }}
                >
                  <button className="btn btn-primary d-block blockquote mb-4 w-100 font-weight-bold text-center p-2">
                    My Draft Listings
                  </button>
                </Link>
              </div>
              <div className="form-group card-bg-color rounded mb-4 p-4">
                <div className="form-label mb-3 h4">Clients </div>
                <Link
                  to="/RegisterAClient"
                  style={{ textDecoration: 'none' }}
                >
                  <button className="btn btn-primary d-block blockquote mb-4 w-100 font-weight-bold text-center p-2">
                    Register New Client
                  </button>
                </Link>
                <Link
                  to="/MyClients"
                  style={{ textDecoration: 'none' }}
                >
                  <button className="btn btn-primary d-block blockquote mb-4 w-100 font-weight-bold text-center p-2">
                    My Clients
                  </button>
                </Link>
              </div>
              <div className="form-group card-bg-color rounded p-4">
                <h4 className="form-label mb-3">Properties </h4>
                <Link
                  to="/PropertySearch"
                  style={{ textDecoration: 'none' }}
                >
                  <button className="btn btn-primary d-block blockquote mb-4 w-100 font-weight-bold text-center p-2">
                    Property Search
                  </button>
                </Link>
                <Link
                  to="/HotProperties"
                  style={{ textDecoration: 'none' }}
                >
                  <button className="btn btn-primary d-block blockquote mb-4 w-100 font-weight-bold text-center p-2">
                    Hot Properties
                  </button>
                </Link>
                <Link
                  to="/PropertyRecentListings"
                  style={{ textDecoration: 'none' }}
                >
                  <button className="btn btn-primary d-block blockquote mb-4 w-100 font-weight-bold text-center p-2">
                    Recent Listings
                  </button>
                </Link>
              </div>
            </div>
          </form>
          <div className="d-flex flex-row justify-content-between align-items-center">
            <small className="text-muted">
              {AppConstants.BUILD_NUMBER}
            </small>
            <small className="text-muted">
              {AppConstants.BUILD_DATE}
            </small>
          </div>
        </div>
      </div>
    </div>
  );
}
